import { render } from "./Marks.vue?vue&type=template&id=5c57c1b0"
import script from "./Marks.vue?vue&type=script&lang=js"
export * from "./Marks.vue?vue&type=script&lang=js"
script.render = render

export default script